var BookmarksButton    = require("./BookmarksButton"),
    BrandDropdown      = require("./BrandDropdown"),
    ButtonRequirements = require("./ButtonRequirements"),
    CategoryDropdown   = require("./CategoryDropdown"),
    DropdownLayout     = require("app/AppLayout/DropdownLayout"),
    HyperLinkSupport   = require("enyo-ui/HyperLinkSupport"),
    IconButton         = require("app/ui/IconButton"),
    LanguageSwitcher   = require("./LanguageSwitcher"),
    Layout             = require("./HeaderLayout"),
    LoginButton        = require("./LoginButton"),
    Logo               = require("app/ui/logo/Logo"),
    MenuDropdown       = require("./MenuDropdown"),
    PreviewModeButton  = require("./PreviewModeButton"),
    SignUpButton       = require("./SignUpButton"),
    buttons            = require("app/theme/buttons"),
    config             = require("app/config"),
    frameThrottle      = require("enyo-perf/utils").frameThrottle,
    get                = require("object-path").get,
    icons              = require("app/theme/icons"),
    kind               = require("enyo/kind"),
    onHyperlinkTap     = require("app/utils/onHyperlinkTap"),
    quickMacroize      = require("enyo/macroize").quickMacroize;

require("./HeaderView.less");
require("app/theme/IconButton--header.less");

module.exports = kind(/** @lends  app.AppHeader.HeaderView.prototype */ {

    /**
     * @private
     */
    name: "app.AppHeader.HeaderView",

    /**
     * @private
     */
    classes: "app-app-header-header-view",

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * @private
     * Don't render until app is started.
     *
     * @private
     */
    canGenerate: false,

    /**
     * @type {Boolean}
     * @public
     */
    showBackButton: null,

    /**
     * @private
     */
    components: [{
        classes:    "app-app-header-header-view__top",
        components: [{
            name:          "backButton",
            kind:          IconButton,
            classes:       "app-app-header-header-view__back-button",
            showing:       false,
            theme:         buttons["app.AppHeader.HeaderView.backButton"],
            icon:          icons["app.AppHeader.HeaderView.backButton"],
            iconAlignment: "left",
            ontap:         "onBackButtonTap"
        }, {
            name:       "logo",
            classes:    "app-app-header-header-view__logo",
            components: [{
                name:        "buildModeLabel",
                classes:     "app-app-header-header-view__build-mode-label",
                canGenerate: Boolean(config.buildModeLabel)
            }, {
                name:    "logoImage",
                kind:    Logo,
                classes: config.buildModeLabel
                    ? "app-app-header-header-view__logo-image-with-build-mode-label"
                    : "app-app-header-header-view__logo-image"
            }],
            mixins:       [HyperLinkSupport],
            forceRefresh: true,
            showing:      true,
            ontap:        "onHyperlinkTap"
        }, {
            name:               "previewModeButton",
            kind:               PreviewModeButton,
            classes:            "app-app-header-header-view__preview-mode-button",
            showing:            false,
            theme:              buttons["app.AppHeader.HeaderView.previewModeButton"],
            loadingIcon:        icons["app.AppHeader.HeaderView.PreviewModeButton.loading"],
            previewModeOnIcon:  icons["app.AppHeader.HeaderView.PreviewModeButton.previewModeOn"],
            previewModeOffIcon: icons["app.AppHeader.HeaderView.PreviewModeButton.previewModeOff"],
            iconAlignment:      "right"
        }, {
            name:          "searchButton",
            kind:          IconButton,
            mixins:        [HyperLinkSupport],
            classes:       "app-app-header-header-view__search-button",
            showing:       false,
            theme:         buttons["app.AppHeader.HeaderView.searchButton"],
            icon:          icons["app.AppHeader.HeaderView.searchButton"],
            iconAlignment: "left",
            ontap:         "onHyperlinkTap"
        }, {
            name:          "playlistsButton",
            kind:          IconButton,
            mixins:        [HyperLinkSupport],
            classes:       "app-app-header-header-view__playlists-button",
            showing:       false,
            theme:         buttons["app.AppHeader.HeaderView.playlistsButton"],
            icon:          icons["app.AppHeader.HeaderView.playlistsButton"],
            iconAlignment: "left",
            ontap:         "onHyperlinkTap"
        }, {
            name:        "bookmarksButton",
            kind:        BookmarksButton,
            classes:     "app-app-header-header-view__bookmarks-button",
            showing:     false,
            theme:       buttons["app.AppHeader.HeaderView.bookmarksButton"],
            loadingIcon: icons["app.AppHeader.HeaderView.BookmarksButton.loading"],
            loadedIcon:  icons["app.AppHeader.HeaderView.BookmarksButton.loaded"]
        }, {
            name:          "genresButton",
            kind:          IconButton,
            mixins:        [HyperLinkSupport],
            classes:       "app-app-header-header-view__genres-button",
            showing:       false,
            theme:         buttons["app.AppHeader.HeaderView.genresButton"],
            icon:          icons["app.AppHeader.HeaderView.genresButton"],
            iconAlignment: "left",
            ontap:         "onHyperlinkTap"
        }, {
            name:          "artistsButton",
            kind:          IconButton,
            mixins:        [HyperLinkSupport],
            classes:       "app-app-header-header-view__artists-button",
            showing:       false,
            theme:         buttons["app.AppHeader.HeaderView.artistsButton"],
            icon:          icons["app.AppHeader.HeaderView.artistsButton"],
            iconAlignment: "left",
            ontap:         "onHyperlinkTap"
        }, {
            name:          "categoryDropdown",
            kind:          CategoryDropdown,
            classes:       "app-app-header-header-view__category-dropdown",
            showing:       false,
            layoutKind:    DropdownLayout,
            layoutOptions: {
                alignment:    "contentRegion",
                scrollerPath: ".$.categoryMenu.$.scroller"
            },
            activatorOptions: {
                theme:         buttons["app.AppHeader.HeaderView.CategoryDropdown.activator"],
                loadingIcon:   icons["app.AppHeader.HeaderView.CategoryDropdown.Activator.loading"],
                loadedIcon:    icons["app.AppHeader.HeaderView.CategoryDropdown.Activator.loaded"],
                iconAlignment: "left"
            },
            blockContentInteraction: true,
            propagateCapturedTap:    true
        }, {
            name:          "brandDropdown",
            kind:          BrandDropdown,
            classes:       "app-app-header-header-view__brand-dropdown",
            showing:       false,
            layoutKind:    DropdownLayout,
            layoutOptions: {
                alignment:    "contentRegion",
                scrollerPath: ".$.brandMenu.$.scroller"
            },
            activatorOptions: {
                theme:         buttons["app.AppHeader.HeaderView.BrandDropdown.activator"],
                loadingIcon:   icons["app.AppHeader.HeaderView.BrandDropdown.Activator.loading"],
                loadedIcon:    icons["app.AppHeader.HeaderView.BrandDropdown.Activator.loaded"],
                iconAlignment: "left"
            },
            blockContentInteraction: true,
            propagateCapturedTap:    true
        }, {
            name:          "loginButton",
            kind:          LoginButton,
            classes:       "app-app-header-header-view__login-button",
            showing:       false,
            theme:         buttons["app.AppHeader.HeaderView.loginButton"],
            loadingIcon:   icons["app.AppHeader.HeaderView.LoginButton.loading"],
            loggedInIcon:  icons["app.AppHeader.HeaderView.LoginButton.loggedIn"],
            loggedOutIcon: icons["app.AppHeader.HeaderView.LoginButton.loggedOut"]
        }, {
            name:    "signUpButton",
            kind:    SignUpButton,
            classes: "app-app-header-header-view__sign-up-button",
            showing: false,
            theme:   buttons["app.AppHeader.HeaderView.signUpButton"],
            icon:    icons["app.AppHeader.HeaderView.signUpButton"]
        }, {
            name:          "languageSwitcher",
            kind:          LanguageSwitcher,
            classes:       "app-app-header-header-view__language-switcher",
            showing:       false,
            layoutKind:    DropdownLayout,
            layoutOptions: {
                alignment:    "contentRegion",
                scrollerPath: ".$.languageMenu.$.scroller"
            },
            blockContentInteraction: true,
            propagateCapturedTap:    true
        }, {
            name:          "menuDropdown",
            kind:          MenuDropdown,
            classes:       "app-app-header-header-view__menu-dropdown",
            layoutKind:    DropdownLayout,
            layoutOptions: {
                alignment:    "contentRegion",
                scrollerPath: ".$.scroller"
            },
            blockContentInteraction: true,
            propagateCapturedTap:    true,
            showing:                 false
        }]
    }, {
        name:       "previewModeBar",
        classes:    "app-app-header-header-view__preview-mode-bar",
        showing:    false,
        components: [{
            name:    "previewModeBarLabel",
            classes: "app-app-header-header-view__preview-mode-bar-label"
        }]
    }, {
        name: "buttonRequirements",
        kind: ButtonRequirements
    }],

    /**
     * @private
     */
    bindings: [{
        from: "state",
        to:   ".$.buttonRequirements.state"
    }],

    /**
     * @private
     */
    observers: {
        update: ["state", "showBackButton"]
    },

    /**
     * @private
     */
    handlers: {
        onButtonRequirementsChanged: "onButtonRequirementsChanged"
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update     = frameThrottle(this.bindSafely(this.update));
            this.lazyResize = frameThrottle(this.bindSafely(this.resize));
            sup.apply(this, arguments);
            this.observe("app.started", this.onAppStartedChange);
            this.observe("app.$.authService.isLoggedIn", this.update);
            this.observe("app.$.authService.user", this.update);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * Render once app is started. By then language and authentication should be
     * resolved so we won't be rendering any broken urls without language
     * fragments and such.
     *
     * @private
     */
    onAppStartedChange: function() {
        if (this.app.get("started") === 1) {
            this.set("canGenerate", true);
            this.render();
        }
    },

    /**
     * @protected
     */
    update: function() {
        var $i18nService     = this.app.$.i18nService,
            state            = this.state || {},
            $searchButton    = this.$.searchButton,
            $playlistsButton = this.$.playlistsButton,
            $genresButton    = this.$.genresButton,
            $artistsButton   = this.$.artistsButton,
            playlistsPageUrl = get(config, "pageUrls.playlistsPageUrl", null),
            genresPageUrl    = get(config, "pageUrls.genresPageUrl", null),
            artistsPageUrl   = get(config, "pageUrls.artistsPageUrl", null);

        // Update back button visibility
        this.$.backButton.set("tooltip", $i18nService.getString("app.AppHeader.BackButton.tooltip"));

        // Update contents
        this.$.logo.set("href", quickMacroize("/{$language}/home", {
            language: $i18nService.get("language")
        }));
        this.$.logo.setAttribute("title", $i18nService.getString("app.AppHeader.Logo.tooltip"));
        this.$.buildModeLabel.set("content", config.buildModeLabel);

        // Preview Mode Button
        this.$.previewModeBarLabel.set("content", $i18nService.getString("app.AppHeader.PreviewModeBar.caption"));

        // Search Button
        $searchButton.set("caption", $i18nService.getString("app.AppHeader.SearchButton.caption"));
        $searchButton.set("tooltip", $i18nService.getString("app.AppHeader.SearchButton.tooltip"));
        $searchButton.set("href", quickMacroize("/{$language}/search", {
            language: $i18nService.get("language")
        }));

        // Playlists Button
        $playlistsButton.set("caption", $i18nService.getString("app.AppHeader.PlaylistsButton.caption"));
        $playlistsButton.set("tooltip", $i18nService.getString("app.AppHeader.PlaylistsButton.tooltip"));
        $playlistsButton.set("href", playlistsPageUrl ? quickMacroize(playlistsPageUrl, {
            language: $i18nService.get("language")
        }) : null);

        // Genres Button
        $genresButton.set("caption", $i18nService.getString("app.AppHeader.GenresButton.caption"));
        $genresButton.set("tooltip", $i18nService.getString("app.AppHeader.GenresButton.tooltip"));
        $genresButton.set("href", genresPageUrl ? quickMacroize(genresPageUrl, {
            language: $i18nService.get("language")
        }) : null);

        // Artists Button
        $artistsButton.set("tooltip", $i18nService.getString("app.AppHeader.ArtistsButton.tooltip"));
        $artistsButton.set("caption", $i18nService.getString("app.AppHeader.ArtistsButton.caption"));
        $artistsButton.set("href", artistsPageUrl ? quickMacroize(artistsPageUrl, {
            language: $i18nService.get("language")
        }) : null);

        // Category Dropdown
        this.$.categoryDropdown.set("state", state);

        // Brand Dropdown
        this.$.brandDropdown.set("state", state);

        // Language Switcher
        this.$.languageSwitcher.set("state", state);

        // Menu Dropdown
        this.$.menuDropdown.set("state", state);

        // Trigger reflow
        this.lazyResize();
    },

    /**
     * Trigger reflow.
     *
     * @returns  {boolean}  Stop propagation
     * @private
     */
    onButtonRequirementsChanged: function() {
        this.lazyResize();

        return true;
    },

    /**
     * Instruct the router to navigate to the new location
     *
     * @param   {enyo.Control}  sender  The sender
     * @return  {boolean}       Stop propagation
     * @private
     */
    onHyperlinkTap: onHyperlinkTap,

    /**
     * Instruct the router to navigate to the previous location
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    onBackButtonTap: function() {
        this.app.$.router.back(true);

        return true;
    }

});
